import { getTenantIdByHost, TenantId } from 'tenants';
import configJSON from 'config.json';
import { isClientSide } from 'utils/host-config';

/**
 * Hook to get the current tenant ID.
 * 
 * This hook determines the tenant ID by checking the current host using the existing
 * {@link getTenantIdByHost} utility, which already handles all tenant matching logic.
 * This is a clean alternative to using the (deprecated) useThemeContext hook for tenant identification.
 * 
 * @returns The current tenant ID
 */
export function useTenantId(): TenantId {
  // In browser environment, use window.location.host
  if (isClientSide()) {
    return getTenantIdByHost(window.location.host, configJSON.defaultTenantId as TenantId)!;
  }
  
  // Fallback to default tenant (for SSR or when host cannot be determined)
  return configJSON.defaultTenantId as TenantId;
}

